module.exports = __webpack_public_path__ + "static/wareef-pillar-of-the-gcc@2x-60549719f61adddd47e3d113d9d4ad22.jpg";